import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Tema unico chiaro (il tema scuro è stato tolto col restyling 2026)
document.documentElement.setAttribute('data-theme', 'light');

// Build dell'ambiente di sviluppo: striscia fissa per non confonderlo mai con quello vero
const SVILUPPO = process.env.REACT_APP_AMBIENTE === 'sviluppo';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    {SVILUPPO && (
      <div style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 99999, background: '#d97706', color: '#fff', textAlign: 'center', fontSize: 12, fontWeight: 700, letterSpacing: 0.5, padding: '3px 8px', pointerEvents: 'none' }}>
        AMBIENTE DI SVILUPPO — copia dei dati, nessuna email parte — <span style={{ pointerEvents: 'auto' }}><a href="/riservato-sviluppo/esci" style={{ color: '#fff' }}>torna al gestionale vero</a></span>
      </div>
    )}
    <App />
  </>
);
